import { keys } from "ramda";

export const DEFAULT_LOCALE = "en" as const;

export type LocaleConfig = {
    fullName: string;
    rtl: boolean;
    name: string;
};

export const LOCALES_CONFIG = {
    en: {
        name: "en",
        fullName: "en_US",
        rtl: false,
    },
    ar: {
        name: "ar",
        fullName: "ar_SA",
        rtl: true,
    },
    ru: {
        name: "ru",
        fullName: "ru_RU",
        rtl: false,
    },
    es: {
        name: "es",
        fullName: "es_ES",
        rtl: false,
    },
    fr: {
        name: "fr",
        fullName: "fr_FR",
        rtl: false,
    },
    vi: {
        name: "vi",
        fullName: "vi_VN",
        rtl: false,
    },
    zh: {
        name: "zh_Hans",
        fullName: "zh_Hans",
        rtl: false,
    },
    ko: {
        name: "ko",
        fullName: "ko_KR",
        rtl: false,
    },
    pcm: {
        name: "pcm",
        fullName: "pcm_NG",
        rtl: false,
    },
    sw: {
        name: "sw",
        fullName: "sw_KE",
        rtl: false,
    },
    "pt-br": {
        name: "pt_BR",
        fullName: "pt_BR",
        rtl: false,
    },
    "zh-hant": {
        name: "zh_Hant",
        fullName: "zh_Hant",
        rtl: false,
    },
} satisfies Record<string, LocaleConfig>;

export const LOCALES = keys(LOCALES_CONFIG);

export const RTL_LOCALES = LOCALES.filter((locale) => LOCALES_CONFIG[locale].rtl);
